export enum QuotationRequestState {
    Idle,
    Processing,
    CompleteLead,
    CompleteDraft,
    CompleteDelete,
    Failed,
    CompleteOffer,
    InvalidShip
}
